var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 26,
    fill: "none",
    viewBox: "0 0 11 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4141",
    d: "M5.60156 25.75C6.09375 25.75 6.9375 23.7344 6.9375 20.8164V9.625C8.96484 9.05078 10.4414 7.16406 10.4414 4.96094C10.4414 2.27734 8.28516 0.0976562 5.60156 0.0976562C2.90625 0.0976562 0.75 2.27734 0.75 4.96094C0.75 7.16406 2.21484 9.03906 4.24219 9.625V20.8164C4.24219 23.7227 5.09766 25.75 5.60156 25.75ZM4.21875 5.24219C3.33984 5.24219 2.56641 4.45703 2.56641 3.56641C2.56641 2.66406 3.33984 1.91406 4.21875 1.91406C5.13281 1.91406 5.87109 2.66406 5.87109 3.56641C5.87109 4.45703 5.13281 5.24219 4.21875 5.24219Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d766f15ae6266bac563bf8f91d5d0f14.svg";
export { ForwardRef as ReactComponent };